import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ArkUnitOfWork } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityQuery } from 'breeze-client';
import _ from 'lodash';
import { Person } from 'app/core/model/entity-model';
import moment from 'moment';

@Component({
    selector: 'app-survey-detail',
    templateUrl: './survey-detail.component.html',
    styleUrls: ['./survey-detail.component.scss'],
    providers: [ArkUnitOfWork]
})
export class SurveyDetailComponent implements OnInit {
    person: Person;
    personId: any;
    interests: any[];
    categories: any;

    constructor(private uow: ArkUnitOfWork, private route: ActivatedRoute, private router: Router, protected location: Location) {}

    async ngOnInit() {
        this.personId = this.route.snapshot.params['id'];

        this.interests = await this.uow.interests.all('interestCategory.displayOrder,displayOrder', 'interestCategory');
        this.categories = this.uow.manager.executeQueryLocally(EntityQuery.from('InterestCategories'));
        // this.categories = await this.uow.interests.all('displayOrder,', 'interests');
        this.person = await this.uow.people.byId(this.personId, 'personInterests');

        _(this.interests)
            .intersectionWith(this.person.personInterests, (a: any, b: any) => a.id === b.interestId)
            .forEach(i => (i.selected = true));
    }

    async save() {
        const selectedInterests = _(this.interests)
            .filter({ selected: true } as any)
            .value();

        const toDelete = _(this.person.personInterests)
            .differenceWith(selectedInterests, (a: any, b: any) => a.interestId === b.id)
            .value();
        const toInsert = _(selectedInterests)
            .differenceWith(this.person.personInterests, (a: any, b: any) => a.id === b.interestId)
            .value();

        toDelete.forEach(i => i.entityAspect.setDeleted());
        toInsert.forEach(i => this.uow.manager.createEntity('PersonInterest', { interestId: i.id, personId: this.personId }));
        await this.uow.commit();
        this.close();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    today() {
        this.person.interestsLastUpdated = moment()
            .startOf('day')
            .toDate();
    }

    clear() {
        this.interests.forEach(i => (i.selected = false));
    }
}
